export const FILTERMANGA_ITEM = {
  country: {
    label: {
      vi: 'Quốc gia',
      en: 'Country',
    },
    listData: {
      pvn: {
        vi: 'Truyện Việt Nam',
        en: 'Vietnamese film',
        value: 'pvn',
      },
      ptl: {
        vi: 'Truyện Thái Lan',
        en: 'Thailand film',
        value: 'ptl',
      },
      phq: {
        vi: 'Truyện Hàn Quốc',
        en: 'Korea film',
        value: 'phq',
      },
      pnb: {
        vi: 'Truyện Nhật Bản',
        en: 'Japanese film',
        value: 'pnb',
      },
      pm: {
        vi: 'Truyện Mỹ',
        en: 'United State film',
        value: 'pm',
      },
      pad: {
        vi: 'Truyện Ấn Độ',
        en: 'Indian film',
        value: 'pad',
      },
      phk: {
        vi: 'Truyện Hồng Kông',
        en: 'HongKong film',
        value: 'phk',
      },
      ptw: {
        vi: 'Truyện Đài Loan',
        en: 'Taiwan film',
        value: 'ptw',
      },
    },
  },
  category: {
    label: {
      vi: 'Thể loại',
      en: 'Category',
    },
    listData: {
      phd: {
        vi: 'Truyện Hành Động',
        en: 'Vietnamese film',
        value: 'phd',
      },
      ptc: {
        vi: 'Truyện Tình Cảm',
        en: 'Thailand film',
        value: 'ptc',
      },
      pvt: {
        vi: 'Truyện Viễn Tưởng',
        en: 'Korea film',
        value: 'pvt',
      },
      ph: {
        vi: 'Truyện Hài',
        en: 'Japanese film',
        value: 'ph',
      },
      ptl: {
        vi: 'Truyện Tâm Lý',
        en: 'United State film',
        value: 'ptl',
      },
      ptli: {
        vi: 'Truyện Tài Liệu',
        en: 'Indian film',
        value: 'ptli',
      },
      pct: {
        vi: 'Truyện Cổ Trang',
        en: '',
        value: 'pct',
      },
      pkd: {
        vi: 'Truyện Kinh Dị',
        en: '',
        value: 'pkd',
      },
      pvth: {
        vi: 'Truyện Võ Thuật',
        en: '',
        value: 'pvth',
      },
    },
  },
  year: {
    label: {
      vi: 'Năm phát hành',
      en: 'Release year',
      value: 'pvn',
    },
    listData: {
      _2022: {
        vi: '2022',
        en: '2022',
        value: '2022',
      },
      _2021: {
        vi: '2021',
        en: '2021',
        value: '2021',
      },
      _2020: {
        vi: '2020',
        en: '2020',
        value: '2020',
      },
      _2019: {
        vi: '2019',
        en: '2019',
        value: '2019',
      },
      _2018: {
        vi: '2018',
        en: '2018',
        value: '2018',
      },
      _2017: {
        vi: '2017',
        en: '2017',
        value: '2017',
      },
      _2016: {
        vi: '2016',
        en: '2016',
        value: '2016',
      },
      _2015: {
        vi: '2015',
        en: '2015',
        value: '2015',
      },
      _2014: {
        vi: '2014',
        en: '2014',
        value: '2014',
      },
      _2013: {
        vi: '2013',
        en: '2013',
        value: '2013',
      },
      _2012: {
        vi: '2012',
        en: '2012',
        value: '2012',
      },
      _2011: {
        vi: '2011',
        en: '2011',
        value: '2011',
      },
      _2010: {
        vi: '2010',
        en: '2010',
        value: '2010',
      },
      etc: {
        vi: 'Trước 2010',
        en: 'Before 2010',
        value: 'etc',
      },
    },
  },
  publishing: {
    label: {
      vi: 'Nhà xuất bản',
      en: 'Publishing company',
    },
    listData: {
      kimdong: {
        vi: 'Kim đồng',
        en: 'Kim đồng',
        value:'kimdong'
      },
      tuoitre: {
        vi: 'Tuổi trẻ',
        en: 'Tuổi trẻ',
        value:'tuoitre'
      },
      mangnon: {
        vi: 'Măng non',
        en: 'Măng non',
        value:'mangnon'
      },
      kenh14: {
        vi: 'Kênh 14',
        en: 'Kênh 14',
        value:'kenh14'
      },
    },
  },
  filterManga: {
    category: '',
    country: '',
    year: '',
    publishing:'',
    name: '',
  },
};
